// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.dropdown-menu[data-v-2564cc83] {\r\n  background-color: transparent;\r\n  border: none;\n}\na[data-v-2564cc83]:hover {\r\n  text-decoration: none !important;\n}\r\n", ""]);
// Exports
module.exports = exports;
